import React from "react";

import { IgRadio, IgTypography } from "@intelligems/ig-theme";
import {
  ChannelType,
  ConversionStageReachedType,
  DeviceType,
  StatSigViewType,
  VisitorType,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { conversionStageReachedList } from "@src/components/AudienceFilters/utils";

interface ConversionStageReachedFilterProps {
  conversionStageReached: ConversionStageReachedType;
  onStringFilterChange: (
    newValue:
      | DeviceType
      | VisitorType
      | ChannelType
      | StatSigViewType
      | ConversionStageReachedType,
    filterKey:
      | "statSigView"
      | "deviceType"
      | "channelType"
      | "visitorType"
      | "reachedCheckoutStage"
  ) => void;
}
export const ConversionStageReachedFilter = ({
  conversionStageReached,
  onStringFilterChange,
}: ConversionStageReachedFilterProps) => {
  const selectedRadio = (selectedVisitorType: string | undefined): boolean => {
    if (!conversionStageReached) return false;
    return conversionStageReached === selectedVisitorType;
  };

  return (
    <Grid container direction={"column"}>
      {conversionStageReachedList.map((conversionStage, index: number) => (
        <Grid
          item
          key={conversionStage.key}
          onClick={() =>
            onStringFilterChange(conversionStage.key, "reachedCheckoutStage")
          }
          sx={{ "& :hover": { cursor: "pointer" } }}
        >
          <IgRadio
            label={conversionStage.label}
            checked={selectedRadio(conversionStage.key)}
          />
        </Grid>
      ))}
    </Grid>
  );
};
